//JCarousel

(function($) {
    $(function() {
        $('.jcarousel').on('jcarousel:reload jcarousel:create', function () {
            var carousel = $(this),
                width = carousel.innerWidth();
            carousel.jcarousel('items').css('width', width + 'px');
        }).jcarousel({
            wrap: 'circular',
            center: true
        }).jcarouselAutoscroll({
            interval: 5000
        }).on('jcarousel:animateend', function () {
            $(window).trigger('scroll');
        });

        $('.jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function() {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function() {
                $(this).removeClass('active');
            })
            .jcarouselPagination({
                item: function(page, carouselItems) {
                    return '<a>' + page + '</a>';
                }
            });
    });
})(jQuery);